import React from "react"
import game from "yams.png"

const Yams = props => <img src={game} className="game" {...props} />

export default Yams
